{
  "heatNumber":"Heat number",
  "grade":"Grade",
  "begin":"Inicio",
  "end":"Fin",
  "ladle":"Ladle",
  "weight":"Peso",
  "samples":"Muestras",
  "buckets":"Cestas",
  "alloys":"Aleaciones",
  "delays":"Demoras",
  "status":"Estado",
  "temperature":"Temperatura",
  "tapToTapTemperature":"Temperatura TapToTap",
  "sourceName":"Fuente",
  "variables":"Variables"
}
